import { render, staticRenderFns } from "./tm37fug.vue?vue&type=template&id=a4873d6a"
import script from "./tm37fug.vue?vue&type=script&lang=js"
export * from "./tm37fug.vue?vue&type=script&lang=js"
import style0 from "./tm37fug.vue?vue&type=style&index=0&id=a4873d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports